module.exports = __webpack_public_path__ + "static/12-bf90aad501a00ea5353ab5cfeabf9adf.jpeg";